import { c as _c } from "react/compiler-runtime";
/**
 * 상담 신청 랜딩 — INVESTORS / BACKED BY 섹션.
 * 레퍼런스: medigeo-landing.html `.investors`. 투자사 로고는 단일 strip PNG(2053×118)로,
 * 회색조 + 데스크톱 hover 시 컬러. 모바일에서는 strip 가독성 위해 가로 스크롤(min-w).
 * 카피·포인트 색상은 리뷰드 랜딩 컨벤션(NanumSquare Neo 제목 / 회색 eyebrow / 보라 포인트)으로 변환.
 */
const Investors = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <p className="text-[13px] font-semibold uppercase tracking-wide text-[#6a6d75]">Backed by</p>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="mx-auto flex max-w-[680px] flex-col items-center gap-3 text-center">{t0}<h2 className="text-balance break-keep font-[family-name:var(--font-nanum-square-neo)] text-[30px] font-extrabold leading-[1.35] tracking-[-0.84px] text-[#121212] sm:text-[34px] lg:text-[40px] lg:tracking-[-1.2px]">주요 투자사들이 <span className="font-black text-[#7a33ff]">리뷰드</span>와 함께합니다</h2><p className="text-balance break-keep text-[16px] leading-[1.6] text-[#374151] sm:text-[16px] lg:text-[17px]">아래 벤처캐피탈·금융기관으로부터 투자를 유치하며 서비스의 신뢰성과 성장 가능성을 인정받았습니다.</p></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <section id="investors" className="w-full bg-[#f6f7fb]"><div className="mx-auto max-w-[1140px] px-5 pb-12 pt-16 lg:px-0 lg:pb-16 lg:pt-20">{t1}<div className="mx-auto mt-10 max-w-[980px] overflow-x-auto rounded-[22px] border border-[#e1e9f3] bg-white px-6 py-7 shadow-[0_4px_24px_rgba(16,20,62,0.06)] lg:mt-12 lg:px-[50px] lg:py-10"><img src="/inquiry-landing/investors/investor-logos.png" alt={"\uD604\uB300\uD22C\uC790\uD30C\uD2B8\uB108\uC2A4, \uC2E0\uC6A9\uBCF4\uC99D\uAE30\uAE08, \uC18C\uD48D\uBCA4\uCC98\uC2A4(sopoong), \uB354\uBCA4\uCC98\uC2A4(the ventures), ROUE, \uB9AC\uBCA4\uCC98\uC2A4(Reventures) \uB4F1 \uB9AC\uBDF0\uB4DC \uD22C\uC790\uC0AC"} width={2053} height={118} loading="lazy" className="block h-auto w-full min-w-[560px] opacity-70 grayscale transition duration-500 hover:opacity-100 hover:grayscale-0 lg:min-w-0" /></div></div></section>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export default Investors;